import './createShopBox.scss';
import { useNavigate } from 'react-router-dom';
import { Button } from 'tedooo-web-design-system/ui';

import { EmptyState } from 'components/emptyState';
import { EmptyStateOptions } from 'components/emptyState/types';
import { ROUTES } from 'constant';
import { translations } from 'translations/en';

const CreateShopBox = () => {
  const navigate = useNavigate();

  const onClick = () => navigate(`/${ROUTES.CREATE_SHOP}`);

  return (
    <div className="create-shop-box">
      <EmptyState
        type={EmptyStateOptions.CreateShop}
        button={
          <Button
            type="primary"
            size="medium"
            borderRadius="large"
            isFullWidth
            text={translations.SHOP.CREATE_SHOP_BUTTON_TEXT}
            onClick={onClick}
          />
        }
      />
    </div>
  );
};

export default CreateShopBox;
